import React from 'react'
import Skeleton from 'react-loading-skeleton'

function SkeletonPieChart({legend}){
    const legendPoints = () => <div class="row flex-row justify-content-center mb-3" style={{maxWidth: "100%"}}>
        <div class="col col-sm col-xl-4 col-lg-6 text-center">
            <Skeleton width={10} height={10} inline circle className="mr-1" />
            <Skeleton width={50} height={10} inline />
        </div>
        <div class="col col-sm col-xl-4 col-lg-6 text-center">
            <Skeleton width={10} height={10} inline circle className="mr-1" />
            <Skeleton width={50} height={10} inline />
        </div>
        <div class="col col-sm col-xl-4 col-lg-6 text-center">
            <Skeleton width={10} height={10} inline circle className="mr-1" />
            <Skeleton width={50} height={10} inline />
        </div>
        <div class="d-none col-sm col-xl-4 col-lg-6 d-sm-block text-center">
            <Skeleton width={10} height={10} inline circle className="mr-1" />
            <Skeleton width={50} height={10} inline />
        </div>
        <div class="col-xl-4 d-none d-md-none d-lg-none d-xl-block text-center">
            <Skeleton width={10} height={10} inline circle className="mr-1" />
            <Skeleton width={50} height={10} inline />
        </div>
    </div>
    return <div>
        {legend === "top" && legendPoints()}
        <div class="d-flex justify-content-center text-center">
            <Skeleton width={220} height={220} circle style={{maxWidth: "80%", maxHeight: "80%"}} />        
        </div>
        {legend === "bottom" && legendPoints()}
    </div>
}

SkeletonPieChart.defaultProps = {
    legend: "top"
}

export default SkeletonPieChart